import { useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";

const Games = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const isActive = (id) => (activeTab === id ? "active" : "");
  const showPane = (id) => `tab-pane fade ${activeTab === id ? "active show" : ""}`;

  return (
    <>
      <Breadcrumb breadtitle="Games & Co-Curowicular Activities" breadmid="Academic" breadend="Games/CCA" />
      <div className="innerpage library_blk">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-6 col-md-12">
              <div className="content">
                <ul className="list-view">
                  <li>Students are encouraged to take active part in sports, games,co-curowicular activities and competitions in the school.</li>
                  <li>Parents are requested to encourage their wards to take part in such activities.</li>
                  <li>Students selected for singing, debate, speech, dramatics, elocition, art, and craft competitions, projects, etc. must be willing to spare time for such activities and develop their talents.</li>
                  <li>They should participate in Inter-House Competitions and school functions.</li>
                  <li>Students should play games and sports in a true spirit of sportsmanship and team spirit.</li>
                  <li>Games and sports material should be kept back in the same place without causing and damage to them. In case something is damaged, the teachers in charge is to be informed.</li>
                  <li>No games and sports material will be carowied out of the school premises.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-pills" id="labTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab1")}`}
                    role="tab"
                    aria-selected={activeTab === "tab1"}
                    aria-controls="tabContent1"
                    id="tab1"
                    onClick={() => setActiveTab("tab1")}
                  >
                    HPE-X CBSE
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab2")}`}
                    role="tab"
                    aria-selected={activeTab === "tab2"}
                    aria-controls="tabContent2"
                    id="tab2"
                    onClick={() => setActiveTab("tab2")}
                  >
                    HPE-XII CBSE
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab3")}`}
                    role="tab"
                    aria-selected={activeTab === "tab3"}
                    aria-controls="tabContent3"
                    id="tab3"
                    onClick={() => setActiveTab("tab3")}
                  >
                    Sports Day
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab4")}`}
                    role="tab"
                    aria-selected={activeTab === "tab4"}
                    aria-controls="tabContent4"
                    id="tab4"
                    onClick={() => setActiveTab("tab4")}
                  >
                    Kho-Kho
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab5")}`}
                    role="tab"
                    aria-selected={activeTab === "tab5"}
                    aria-controls="tabContent5"
                    id="tab5"
                    onClick={() => setActiveTab("tab5")}
                  >
                    Cricket
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab6")}`}
                    role="tab"
                    aria-selected={activeTab === "tab6"}
                    aria-controls="tabContent5"
                    id="tab6"
                    onClick={() => setActiveTab("tab6")}
                  >
                    Carowoms
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab7")}`}
                    role="tab"
                    aria-selected={activeTab === "tab7"}
                    aria-controls="tabContent5"
                    id="tab7"
                    onClick={() => setActiveTab("tab7")}
                  >
                    Chess
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab8")}`}
                    role="tab"
                    aria-selected={activeTab === "tab8"}
                    aria-controls="tabContent5"
                    id="tab8"
                    onClick={() => setActiveTab("tab8")}
                  >
                    Yoga Day
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab9")}`}
                    role="tab"
                    aria-selected={activeTab === "tab9"}
                    aria-controls="tabContent5"
                    id="tab9"
                    onClick={() => setActiveTab("tab9")}
                  >Hindi Divas
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Tab panes */}
          <div className="tab-content mt-3">
            <div className={showPane("tab1")} id="tabContent1" role="tabpanel" aria-labelledby="tab1">
              <h5 className="tabhead"><span>HPE-X CBSE</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-6 col-sm-6">

                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-1.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail lazyloaded" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-1.jpg" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-3.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail lazyloaded" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-3.jpg" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-2.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-2.jpg" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-4.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-4.jpg" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-5.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-5.jpg" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-6.jpg">
                        <img alt="Canossa School Lucknow" class="img-thumbnail" src="https://webapi.entab.info/api/image/CSFL/public/images/hpe-X-6.jpg" /></a>
                  </div>
                </div>
                <div class="clr30"></div>
              </div>
            </div>

            <div className={showPane("tab2")} id="tabContent2" role="tabpanel" aria-labelledby="tab2">
              <h5 className="tabhead"><span>HPE-XII CBSE</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/hpe1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/hpe2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/hpe3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/hpe4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/hpe5.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/hpe5.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>


                <div class="clr30"></div>
              </div>
            </div>

            <div className={showPane("tab3")} id="tabContent3" role="tabpanel" aria-labelledby="tab3">
              <h5 className="tabhead"><span>Sports Day</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport5.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport5.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport6.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport6.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport7.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport7.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport8.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport8.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport9.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport9.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport10.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport10.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport11.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport11.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/sport12.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/sport12.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="clr30"></div>
              </div>
            </div>

            <div className={showPane("tab4")} id="tabContent4" role="tabpanel" aria-labelledby="tab4">
              <h5 className="tabhead"><span>Kho-Kho</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/kho1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/kho1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/kho2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/kho2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/kho3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/kho3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/kho4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/kho4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="clr30"></div>
              </div>
            </div>

            <div className={showPane("tab5")} id="tabContent5" role="tabpanel" aria-labelledby="tab5">
              <h5 className="tabhead"><span>Cricket</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket5.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket5.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket6.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket6.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket7.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket7.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/cricket8.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/cricket8.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="clr30"></div>
              </div>
            </div>
            <div className={showPane("tab6")} id="tabContent6" role="tabpanel" aria-labelledby="tab6">
              <h5 className="tabhead"><span>Carowoms</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/carroms1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/carroms1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/carroms2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/carroms2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/carroms3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/carroms3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/carroms4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/carroms4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
              </div>
            </div>

            <div className={showPane("tab7")} id="tabContent7" role="tabpanel" aria-labelledby="tab7">
              <h5 className="tabhead"><span>Chess</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/chess1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/chess1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/chess2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/chess2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/chess3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/chess3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/chess4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/chess4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
              </div>
            </div>

            <div className={showPane("tab8")} id="tabContent8" role="tabpanel" aria-labelledby="tab8">
              <h5 className="tabhead"><span>Yoga Day</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className={showPane("tab9")} id="tabContent9" role="tabpanel" aria-labelledby="tab9">
              <h5 className="tabhead"><span>Yoga Day</span></h5>
              <div class="row g-4">
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga1.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga1.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga2.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga2.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga3.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga3.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 ">
                  <div class="img-box">
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/Yoga4.jpg"><img src="https://webapi.entab.info/api/image/CSFL/public/images/Yoga4.jpg" alt="Canossa School Lucknow" class="img-thumbnail" /></a>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Bottom images */}
         
        </div>
      </div>
    </>
  );
};

export default Games;
